import { Resources } from 'constants/resources';

import { useQuery } from '@tanstack/react-query';
import { getOrderAdjustments } from 'config/requests/orders';

export function useGetOrderAdjustments(id: string | undefined) {
  const { data, isFetching } = useQuery({
    queryKey: [Resources.OrderAdjustments, id],
    queryFn: () => getOrderAdjustments(id!),
    enabled: Boolean(id),
  });

  return {
    data,
    isFetching,
  };
}
